import { Fragment, useCallback, useEffect, useState, useRef } from "react";
import SwiperCore, { Pagination, Navigation, Autoplay, EffectFade } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { useSwiperSettings } from "../../hooks/useSwiperSettings";
import PageHeading from "../../components/__simple/_pageheading";
import { useTranslation } from "react-i18next";
import Car from "../../components/car";
import { OfferSections } from "../../sections/offersSection";
import Breadcrumb from "../../components/__simple/breadcrumb";
import InfoCircle from "../../components/__simple/_infoCirclejsx";
import Info from "../../components/_info";
import { useDispatch } from "react-redux";
import { changeIcons } from "../../_redux/slices/navSlice";
import { useParams } from "react-router";
import axios from "axios";
import { slugSplitter, slugCombine } from "../../utils/slugManager";
import config from "../../configuration/config";
import { Helmet } from "react-helmet";
import useTrackViewCarList from "../../hooks/useTrackViewCarList";
import { groupBy, mapValues, omit } from "lodash";
import ImageGallery from "react-image-gallery";
SwiperCore.use([Pagination, Navigation, Autoplay, EffectFade]);

export function VehiclePage() {
  const { t: trans, i18n } = useTranslation(["inputs", "heading", "vehicales", "info"]);
  const [brandInfo, setBrandInfo] = useState({});
  const [vehicles, setVehicles] = useState([]);
  const [filteredVehicles, setFilteredVehicles] = useState(vehicles);
  const [vehiclesFilter, setVehiclesFilter] = useState(null);
  const [Featured, setFeatured] = useState([]);
  const [filters, setFilters] = useState([]);
  const [offerVehicle, setOfferVehicle] = useState([]);
  const dispatch = useDispatch();
  let { brand } = useParams();
  const [CarCategories, setCarCategories] = useState([]);
  const [seoPageInfo, setSeoPageInfo] = useState({});
  let lang = i18n.language || "ar";
  const languageDir = "language-" + lang;
  const swiperSettings = useSwiperSettings();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 900);
  // Real (stock) images grouped by ProductID — drives the camera on group cards.
  const [cachByProduct, setCachByProduct] = useState({});
  const [gallery, setGallery] = useState([]);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const popRef = useRef(null);

  const openProductGallery = (productId) => {
    const imgs = cachByProduct[productId];
    if (!imgs || imgs.length === 0) return;
    setGallery(imgs);
    if (popRef.current) popRef.current.toggleFullScreen();
  };

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 900);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  function RequsetFeatured() {
    const Body = {
      ObjectSettings: { MetaData: false },
    };

    axios
      .request({
        url: `${config.controllURL}${lang}/api/Pages/DetailsSiteVehicleSpecial`,
        data: Body,
        method: "POST",
        responseType: "json",
      })
      .then(function (response) {
        setFeatured(response.data.ApiObjectData);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  useEffect(() => {
    callback();
  }, [brand]);

  const callback = useCallback(async () => {
    try {
      setFilteredVehicles([]);
      setVehicles([]);
      setOfferVehicle([]);
      setFilters([]);
      setBrandInfo({});

      try {
        try {
          if ("caches" in window) {
            var curl = "site_FetchCarCategories";

            // Opening that particular cache
            const cacheStorage = await caches.open("HJWeb");
            // Fetching that particular cache data
            const cachedResponse = await cacheStorage.match(curl);
            let data = await cachedResponse?.json();
            setCarCategories(data);
          }
        } catch (error) { }

        const response = await axios.post(`${config.controllURL}${lang}/api/Pages/site_FetchCarCategories`, {});
        if (response.status == 200) {
          setCarCategories(response.data);
          const data44 = new Response(JSON.stringify(response.data));

          if ("caches" in window) {
            // Opening given cache and putting our data into it
            caches.open("HJWeb").then((cache) => {
              cache.put("site_FetchCarCategories", data44);
            });
          }
        }
      } catch (error) {
        console.log("error in fetching the countries of SAU", error);
      }

      const res = await axios.request({
        baseURL: config.controllURL,
        url: lang + "/api/home/vehicles/" + slugSplitter(brand),
        method: "get",
      });

      setVehicles(res.data.vehicles);

      // Fetch all real (stock) images once, grouped by ProductID, so each group
      // card can show a camera + gallery when that product has real photos.
      try {
        const snRes = await axios.post(`${config.controllURL}${lang}/api/Pages/siteFetchCarSNImages`, { SN: null });
        if (snRes.status === 200 && Array.isArray(snRes.data)) {
          const gList = [...snRes.data]
            .sort((a, b) => {
              const na = parseFloat(a.Attachment_Comments), nb = parseFloat(b.Attachment_Comments);
              return (isNaN(na) || isNaN(nb)) ? String(a.Attachment_Comments || "").localeCompare(String(b.Attachment_Comments || "")) : na - nb;
            })
            .map((item) => ({
              ...item,
              original: (config.FilePathURL || config.mainURL).replace(/\/$/, "") + item.Image,
              thumbnail: (config.FilePathURL || config.mainURL).replace(/\/$/, "") + item.Image,
              fullscreen: (config.FilePathURL || config.mainURL).replace(/\/$/, "") + item.Image,
              originalHeight: "50", originalWidth: "50", sizes: "50",
            }));
          setCachByProduct(
            mapValues(groupBy(gList.filter((x) => x.ProductID), "ProductID"), (fl) => {
              // A product can have multiple in-stock serials sharing the SAME photos;
              // dedupe by image URL so the gallery doesn't show each image twice.
              const seen = new Set();
              return fl.filter((it) => { if (seen.has(it.Image)) return false; seen.add(it.Image); return true; }).map((it) => omit(it, ["SN", "ProductID"]));
            }),
          );
        }
      } catch (e) { console.log("real images fetch failed", e); }

      const brands = await axios.request({
        baseURL: config.controllURL,
        url: lang + "/api/vehicles/brand/" + slugSplitter(brand),
        method: "get",
      });
      const homeExtraRes = await axios.request({
        baseURL: config.controllURL,
        url: lang + "/api/home/HomeExtra",
        method: "get",
      });
      setOfferVehicle(homeExtraRes.data.offerVehicle);

      const allCategories = brands?.data?.categories;
      var filterHasVehicals = brands?.data?.categories;
      try {
        filterHasVehicals = allCategories?.filter((f) => (res?.data?.vehicles?.filter((c) => c?.category == f?.category)).length > 0);
      } catch (error) { }

      console.log("filterHasVehicals:", filterHasVehicals);
      setFilters(filterHasVehicals);
      setBrandInfo(brands?.data?.brandInfo);
    } catch (error) {
      console.log(error);
    }
    RequsetFeatured();
  }, [brand]);

  // to change the icons color on the navbar
  useEffect(() => {
    dispatch(changeIcons({ iconsBlack: true }));

    return () => {
      dispatch(changeIcons({ iconsBlack: false }));
    };
  }, []);

  useEffect(() => {
    if (vehicles && vehicles.length > 0) filterVehicles(vehiclesFilter);
  }, [vehicles]);

  function filterVehicles(category) {
    setVehiclesFilter(category);
    let filterData;
    if (category != null)
      filterData = vehicles.filter((car) => {
        return car.category === category;
      });

    else {
      filterData = vehicles;
    }
    setFilteredVehicles(filterData);
  }

  useEffect(() => {
    async function fetchSeo() {
      try {
        const page = brand?.includes("Toyota") ? "Toyota cars" : "Lexus Cars";
        const response = await axios.post(`${config.controllURL}${lang}/api/Pages/SiteFetchSeoPages`, {
          page,
        });
        if (response.status === 200 && response.data?.[0]) {
          setSeoPageInfo(response.data[0]);
        }
      } catch (e) {
        console.warn("SEO info unavailable:", e?.message);
      }
    }
    fetchSeo();
  }, [brand]);


  useTrackViewCarList({
    listId: vehiclesFilter ? `${slugSplitter(brand)}_${vehiclesFilter} ` : `${slugSplitter(brand)} _all`,
    listName: vehiclesFilter ? vehiclesFilter : `${slugSplitter(brand)} All Cars`,
    cars: filteredVehicles,
    currency: "SAR",
    creativeSlot: `vehicles_${slugSplitter(brand)} `,
  });


  return (
    <Fragment>
      {seoPageInfo && (
        <Helmet>
          <meta charSet="utf-8" />
          {seoPageInfo?.title && <title>{lang.toLowerCase() == "ar" ? seoPageInfo?.title : (seoPageInfo?.titleEn ?? seoPageInfo?.title)}</title>}
          {seoPageInfo?.link && <link rel="canonical" href={seoPageInfo?.link} />}
          {seoPageInfo?.MetaDescription && (
            <meta name="description" content={lang.toLowerCase() == "ar" ? seoPageInfo?.MetaDescription : (seoPageInfo?.MetaDescriptionEn ?? seoPageInfo?.MetaDescription)} />
          )}
          {seoPageInfo?.MetaGroups && <meta name="keywords" content={lang.toLowerCase() == "ar" ? seoPageInfo?.MetaGroups : (seoPageInfo?.MetaGroupsEn ?? seoPageInfo?.MetaGroups)} />}
        </Helmet>
      )}

      <div className="container mt-xs ">

      </div>
      <div className="container mb-10 ">
        <PageHeading
          fixed={true}
          subtitle={brandInfo?.name && trans("vehicales:showroom").replace("{brand}", brandInfo?.name)}
          title={brandInfo?.name && trans("vehicales:showroom_desc").replace("{brand}", brandInfo?.name)}
        />



        <div className={" mb-32 mt-10 " + languageDir}>
          <div className="model-selector-tabs" style={{ maxWidth: '100%' }}>
            <Swiper
              slidesPerView={"auto"}
              spaceBetween={12}
              centerInsufficientSlides={true}
              slidesOffsetBefore={20}
              slidesOffsetAfter={20}
              className="tabs-swiper"
              style={{ padding: '8px 0' }}
            >
              <SwiperSlide style={{ width: 'auto' }}>
                <div
                  className={`model-chip ${vehiclesFilter === null ? 'selected' : ''}`}
                  onClick={() => filterVehicles(null)}
                  style={{ whiteSpace: 'nowrap' }}
                >
                  <div className="chip-check">
                    <svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" strokeWidth="4"><polyline points="20 6 9 17 4 12"></polyline></svg>
                  </div>
                  <span className="chip-label">{trans("inputs:all")}</span>
                </div>
              </SwiperSlide>

              {
                CarCategories &&
                filters &&
                CarCategories.length > 0 &&
                filters?.length > 0 &&
                CarCategories?.map((item, index) => {
                  const categoryName = item[lang == "ar" ? "NameAr" : "NameEn"];
                  if (item && categoryName && filters.filter((a) => a.category == categoryName)?.length > 0) {
                    return (
                      <SwiperSlide key={index} style={{ width: 'auto' }}>
                        <div
                          className={`model-chip ${vehiclesFilter == categoryName ? 'selected' : ''}`}
                          onClick={() => filterVehicles(categoryName)}
                          style={{ whiteSpace: 'nowrap' }}
                        >
                          <div className="chip-check">
                            <svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" strokeWidth="4"><polyline points="20 6 9 17 4 12"></polyline></svg>
                          </div>
                          <span className="chip-label">{categoryName}</span>
                        </div>
                      </SwiperSlide>
                    );
                  } else {
                    return null;
                  }
                })
              }
            </Swiper>
          </div>
          {isMobile ? (
            <div className="swiper-wrapper-grid-auto mb-16" style={{ margin: '0 -10px' }}>
              <Swiper 
                {...swiperSettings} 
                slidesPerView={1.25}
                spaceBetween={12} 
                pagination={false} 
                resizeObserver={true}
                grabCursor={true}
                className="vehicles-swiper"
              >
                {filteredVehicles?.map((vehicle, index) => (
                  <SwiperSlide key={vehicle.slug + "_" + index} style={{ height: 'auto' }}>
                    <Car
                      key={index}
                      group={vehicle.group}
                      slug={vehicle.slug}
                      year={vehicle.year}
                      colorID={vehicle.colorID}
                      gifts={vehicle.countGifts}
                      groupType={vehicle.carGroupID}
                      modelType={vehicle.type}
                      hybridImage={vehicle.hybridImage}
                      brandImage={vehicle.BrandImage}
                      discountPrice={vehicle.discount}
                      ProductId={vehicle.productId}
                      img={vehicle.image}
                      name={vehicle.name}
                      brand={vehicle.brand}
                      brandID={vehicle?.brandID}
                      category={vehicle.category}
                      minPrice={vehicle.minPrice}
                      Tax={vehicle.Tax}
                      RateCareDiscount={vehicle.RateCareDiscount}
                      newCar={vehicle.newCar}
                      hybird={vehicle.hybird}
                      desc={vehicle.desc}
                      modelTypes={vehicle.modelTypes}
                      link={"/vehicles/" + slugCombine(vehicle.brand, vehicle.otherBrand) + "/" + vehicle.group + "/" + vehicle.year}
                      brandIcon={vehicle.brandIcon}
                      type={vehicle.type}
                      showPric={vehicle.showPric}
                      buyOnline={vehicle?.buyOnline}
                      carData={vehicle}
                      btnShowSN={Boolean(cachByProduct[vehicle?.productId])}
                      onClickShowSN={() => openProductGallery(vehicle?.productId)}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          ) : (
            <div className="nice-row mb-16 vehicle-gap">
              {filteredVehicles?.map((vehicle, index) => {
                return (
                  <div key={vehicle.slug + "_" + index} className="nice-col-lg-3 nice-col-md-4 nice-col-sm-6 my-20">
                    <Car
                      key={index}
                      group={vehicle.group}
                      slug={vehicle.slug}
                      year={vehicle.year}
                      colorID={vehicle.colorID}
                      gifts={vehicle.countGifts}
                      groupType={vehicle.carGroupID}
                      modelType={vehicle.type}
                      hybridImage={vehicle.hybridImage}
                      brandImage={vehicle.BrandImage}
                      discountPrice={vehicle.discount}
                      ProductId={vehicle.productId}
                      img={vehicle.image}
                      name={vehicle.name}
                      brand={vehicle.brand}
                      brandID={vehicle?.brandID}
                      category={vehicle.category}
                      minPrice={vehicle.minPrice}
                      Tax={vehicle.Tax}
                      RateCareDiscount={vehicle.RateCareDiscount}
                      newCar={vehicle.newCar}
                      hybird={vehicle.hybird}
                      desc={vehicle.desc}
                      modelTypes={vehicle.modelTypes}
                      link={"/vehicles/" + slugCombine(vehicle.brand, vehicle.otherBrand) + "/" + vehicle.group + "/" + vehicle.year}
                      brandIcon={vehicle.brandIcon}
                      type={vehicle.type}
                      showPric={vehicle.showPric}
                      buyOnline={vehicle?.buyOnline}
                      carData={vehicle}
                      btnShowSN={Boolean(cachByProduct[vehicle?.productId])}
                      onClickShowSN={() => openProductGallery(vehicle?.productId)}
                    />
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
      <div className="container mb-32">
        <Info />
      </div>
      {offerVehicle && <OfferSections title={trans("info:vehicle_offers")} offersList={offerVehicle} />}
      <div className={"container mb-32 " + languageDir}>
        <div className="mx-20 flex flex-row justify-center flex-wrap items-center nice-gap-1rem">
          {Featured?.map((a) => (
            <InfoCircle icon={"data:image/image;base64," + a.icon} titleAr={a.titleAr} titleEn={a.titleEn} />
          ))}
        </div>
      </div>

      {/* Real-images gallery popup (opened by the camera button on group cards) */}
      <div style={{ opacity: isFullScreen ? 1 : 0, position: isFullScreen ? "relative" : "fixed", zIndex: isFullScreen ? 999999 : -1 }}>
        <ImageGallery
          ref={popRef}
          items={gallery}
          onScreenChange={(e) => setIsFullScreen(e)}
          isRTL={lang === "ar"}
          infinite={true}
          showNav={true}
          thumbnailPosition={"bottom"}
          showBullets={true}
        />
      </div>
    </Fragment>
  );
}
